import { playToFoundation, moveOnTableau, drawCards } from './gameEngine.js';

const AI_SPEED = {
  easy: 2000,
  medium: 1000,
  hard: 400,
};

const AI_MISTAKE_RATE = {
  easy: 0.4,
  medium: 0.15,
  hard: 0.0,
};

export function getAIDelay(difficulty) {
  const base = AI_SPEED[difficulty] || 1000;
  return base + Math.random() * 500;
}

export function makeAIMove(state) {
  const difficulty = state.ai.difficulty;
  if (Math.random() < AI_MISTAKE_RATE[difficulty]) return null;

  const ai = state.ai;

  // Priority 1: Play from pounce pile to foundation
  const pounceTop = ai.pouncePile[ai.pouncePile.length - 1];
  if (pounceTop) {
    const ns = playToFoundation(state, 'ai', 0, 'pouncePile');
    if (ns) return ns;
  }

  // Priority 2: Play top of tableau stacks to foundation
  for (let i = 0; i < ai.tableau.length; i++) {
    const stack = ai.tableau[i] || [];
    if (stack.length === 0) continue;
    const ns = playToFoundation(state, 'ai', i, 'tableau');
    if (ns) return ns;
  }

  // Priority 3: Play from discard to foundation
  const discardTop = ai.drawDiscard[ai.drawDiscard.length - 1];
  if (discardTop) {
    const ns = playToFoundation(state, 'ai', 0, 'drawDiscard');
    if (ns) return ns;
  }

  // Priority 4: Move pounce pile to empty tableau spot
  for (let to = 0; to < ai.tableau.length; to++) {
    if ((ai.tableau[to] || []).length === 0 && ai.pouncePile.length > 0) {
      const ns = moveOnTableau(state, 'ai', 0, to, 'pouncePile', false);
      if (ns) return ns;
    }
  }

  // Priority 5: Move tableau top cards to other tableau spots
  for (let from = 0; from < ai.tableau.length; from++) {
    const fromStack = ai.tableau[from] || [];
    if (fromStack.length === 0) continue;
    for (let to = 0; to < ai.tableau.length; to++) {
      if (from === to) continue;
      const ns = moveOnTableau(state, 'ai', from, to, 'tableau', false);
      if (ns) return ns;
    }
  }

  // Priority 6: Move whole stacks
  for (let from = 0; from < ai.tableau.length; from++) {
    const fromStack = ai.tableau[from] || [];
    if (fromStack.length <= 1) continue;
    for (let to = 0; to < ai.tableau.length; to++) {
      if (from === to) continue;
      const ns = moveOnTableau(state, 'ai', from, to, 'tableau', true);
      if (ns) return ns;
    }
  }

  // Priority 7: Draw cards
  return drawCards(state, 'ai');
}
